export default __webpack_public_path__ + "static/O0163-722d0f8722db75bc976f6099d58c3501.png";